// src/components/PublicationList.jsx
import React from "react";
import PublicationCard from "./PublicationCard";
import "./Styles/PublicationList.scss";

const PublicationList = ({ publications, onSelect }) => {
  return (
    <section className="publication-list">
      {publications.map((pub) => (
        <PublicationCard
          key={pub.id}
          publication={pub}
          onSelect={() => onSelect(pub)}
        />
      ))}
    </section>
  );
};

export default PublicationList;
